module.exports = __webpack_public_path__ + "habana-outpost.c35ba7a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/full/habana-outpost.jpg
// module id = 660
// module chunks = 0